/** Start the admin stylesheet alongside the lazy shell download, never on
 * public/provider entry. Activate it directly so there is no unused preload. */
export function loadAdminFonts(): void {
  if (document.querySelector("link[data-admin-fonts]")) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.dataset.adminFonts = "true";
  link.href = "https://fonts.googleapis.com/css2?family=Geist:wght@400;500;600&family=Geist+Mono:wght@400;500&family=Instrument+Serif:ital@0;1&display=swap";
  document.head.appendChild(link);
}
